export const UPDATE_VENUE_STATUSES= 'UPDATE_VENUE_STATUSES'
export const UPDATE_VENUE_STATUSES_SUCCESS= 'UPDATE_VENUE_STATUSES_SUCCESS'
export const UPDATE_VENUE_STATUSES_ERROR='UPDATE_VENUE_STATUSES_ERROR'

export const UpdateVenueStatuses= (data) => ({
    type: UPDATE_VENUE_STATUSES,
    payload: data
})